import type { MaybeRef } from 'vue';
import { toValue } from 'vue';

import { getDefaultProject, getProject, getProjects } from './api';
import { projectKeys } from './keys';

export const projectsQueryOptions = () => ({
  queryKey: projectKeys.projects(),
  queryFn: () => getProjects().then((response) => response.projects),
  staleTime: Infinity,
  gcTime: Infinity,
});

export const projectQueryOptions = (projectUuid?: MaybeRef<string>) => ({
  queryKey: projectKeys.project(projectUuid),
  queryFn: () =>
    projectUuid
      ? getProject(toValue(projectUuid)).then((response) => response.project)
      : getDefaultProject().then((response) => response.project),
  staleTime: Infinity,
  gcTime: Infinity,
});
